import { FaInstagram } from "react-icons/fa";

export default function InstagramButton() {
  return (
    <a
      href="https://www.instagram.com/homelarauk/"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="instagram-float-btn"
      aria-label="Follow HOMELARA on Instagram"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[linear-gradient(45deg,#FEDA75_0%,#FA7E1E_25%,#D62976_50%,#962FBF_75%,#4F5BD5_100%)] p-4 text-white shadow-2xl transition-transform duration-300 hover:scale-105 sm:bottom-6 sm:right-6"
    >
      <FaInstagram size={24} />
      <span className="hidden md:inline font-mono text-[11px] uppercase tracking-[0.15em] pr-1">
        Follow us on Instagram
      </span>
    </a>
  );
}
